import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { TabsModule } from 'primeng/tabs';
import { CommonModule } from '@angular/common';
import { TextareaModule } from 'primeng/textarea';
import { UserService } from '../../../layout/service/user.service';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { TagModule } from 'primeng/tag';
import { DialogModule } from 'primeng/dialog';
import { FormQuizCase } from './form-quiz-cases';

@Component({
    selector: 'app-form-ekg',
    standalone: true,
    imports: [TabsModule, InputTextModule, ButtonModule, FormsModule, CommonModule, TextareaModule, ToastModule, TagModule, DialogModule, FormQuizCase],
    providers: [MessageService],
    template: `
        <p-toast />
        <p-dialog header="Detail Fields Form" [modal]="true" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '50vw' }" [resizable]="false" [(visible)]="showDetailDialog" position="top" [draggable]="false">
            <div class="mt-3">
                <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div *ngFor="let group of selectedForm?.fields; let gi = index">
                        <div class="mb-2 font-bold">{{ group.name }}</div>
                        <div *ngFor="let field of group.fields; let fi = index" class="flex flex-col gap-3">
                            <label for="field-{{ gi }}-{{ fi }}">{{ field || 'Untitled Field ' + (fi + 1) }}</label>
                            <input pInputText id="field-{{ gi }}-{{ fi }}" disabled />
                        </div>
                    </div>
                </div>
            </div>
        </p-dialog>
        <div class="card">
            <p-tabs [value]="activeIndex">
                <p-tablist>
                    <p-tab [value]="0" (click)="lastTabs(0)">
                        <i class="pi pi-file"></i>
                        <span>Form</span>
                    </p-tab>
                    <p-tab *ngFor="let form of forms; let i = index" [value]="i + 1" (click)="lastTabs(i + 1)">
                        {{ form.name.split(' ')[0] }}
                    </p-tab>
                </p-tablist>
                <p-tabpanels>
                    <p-tabpanel [value]="0">
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <!-- Form Input Side -->
                            <div>
                                <div class="flex flex-col gap-3">
                                    <label for="name">Name</label>
                                    <input pInputText id="name" [(ngModel)]="name" />
                                    <small class="text-gray-500">Please make sure the form name is unique.</small>
                                </div>
                                <div class="mt-4">
                                    <label class="block mb-2">Groups & Fields</label>
                                    <div class="flex flex-col gap-4">
                                        <div *ngFor="let group of fields; let gi = index; trackBy: trackByIndex" class="border rounded p-2 mb-2">
                                            <div class="flex items-center gap-2 mb-2">
                                                <input pInputText [(ngModel)]="fields[gi].name" name="group-{{ gi }}" placeholder="Group name" class="w-full" />
                                                <p-button icon="pi pi-copy" severity="info" [raised]="true" variant="text" (click)="copyGroup(gi)" type="button" [tooltip]="'Copy group & fields'"></p-button>
                                                <p-button icon="pi pi-trash" severity="danger" [raised]="true" variant="text" (click)="removeGroup(gi)" type="button"></p-button>
                                            </div>
                                            <div class="grid grid-cols-1 md:grid-cols-3 gap-2">
                                                <div *ngFor="let field of group.fields; let fi = index; trackBy: trackByIndex">
                                                    <div class="flex items-center gap-2">
                                                        <input pInputText [(ngModel)]="fields[gi].fields[fi]" name="field-{{ gi }}-{{ fi }}" placeholder="Enter field name" class="w-full" />
                                                        <p-button icon="pi pi-trash" severity="danger" [raised]="true" variant="text" (click)="removeField(gi, fi)" type="button"></p-button>
                                                    </div>
                                                </div>
                                            </div>
                                            <p-button label="Add Field" icon="pi pi-plus" severity="success" [raised]="true" variant="text" (click)="addField(gi)" type="button" styleClass="mt-2" />
                                        </div>
                                    </div>
                                    <p-button label="Add Group" icon="pi pi-plus" severity="info" [raised]="true" variant="text" (click)="addGroup()" type="button" styleClass="mt-3" />
                                </div>
                            </div>
                            <!-- Preview Side -->
                            <div>
                                <h5 class="font-semibold text-lg mb-2">Preview</h5>
                                <div class="border p-3 rounded bg-gray-50">
                                    <div class="mt-3">
                                        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
                                            <div *ngFor="let group of fields; let gi = index">
                                                <div class="mb-2 font-bold">{{ group.name }}</div>
                                                <div *ngFor="let field of group.fields; let fi = index" class="flex flex-col gap-3">
                                                    <label for="field-{{ gi }}-{{ fi }}">{{ field || 'Untitled Field ' + (fi + 1) }}</label>
                                                    <input pInputText id="field-{{ gi }}-{{ fi }}" disabled />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <p-button *ngIf="!edit" label="Save Form" icon="pi pi-save" severity="success" [raised]="true" (click)="saveForm()" type="button" styleClass="mt-3" />
                                <div class="flex justify-between" *ngIf="edit">
                                    <p-button *ngIf="edit" label="Update Form" icon="pi pi-pencil" severity="warn" [raised]="true" (click)="onUpdateForm()" type="button" styleClass="mt-3 mr-2" />
                                    <p-button *ngIf="edit" label="Dicard Form" icon="pi pi-trash" severity="danger" [raised]="true" (click)="discardForm()" type="button" styleClass="mt-3" />
                                </div>
                            </div>
                        </div>
                        <hr class="mt-9" />
                        <h3 class="text-primary mb-4">List Form</h3>
                        <div>
                            <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">
                                <div *ngFor="let form of forms; let i = index, trackBy: trackByIndex">
                                    <div class="card-shadow p-3 rounded mb-4 min-h-[220px]">
                                        <div class="flex justify-between items-start gap-2 h-full">
                                            <div>
                                                <h3 class="font-bold text-lg">{{ form.name }}</h3>
                                                <!-- Tag list: horizontal wrap -->
                                                <div class="flex flex-wrap gap-2 mb-5">
                                                    <ng-container *ngFor="let group of form.fields">
                                                        <ng-container *ngFor="let field of group.fields.slice(0, 8)">
                                                            <p-tag severity="info" [value]="field" styleClass="md:text-md text-sm"></p-tag>
                                                        </ng-container>
                                                        <p-tag *ngIf="group.fields.length > 8" severity="warn" [value]="'+' + (group.fields.length - 8) + ' more'"></p-tag>
                                                    </ng-container>
                                                </div>
                                                <small class="text-gray-500">Created: {{ form.created_at | date }}</small>
                                            </div>
                                            <p-tag *ngIf="form.actived == 1" severity="success" [value]="'Active'"></p-tag>
                                            <p-tag *ngIf="form.actived == 0" severity="danger" [value]="'Inactive'"></p-tag>
                                        </div>
                                        <div class="md:flex gap-2 justify-end mt-2">
                                            <p-button label="Show" icon="pi pi-eye" severity="info" [raised]="true" variant="text" (click)="openDetail(form)"  type="button" styleClass="md:mt=0 mt-2 md:mr-0 mr-2"></p-button>
                                            <p-button label="Edit" icon="pi pi-pencil" severity="warn" [raised]="true" variant="text" (click)="editForm(form)"  type="button" styleClass="md:mt=0 mt-2 md:mr-0 mr-2"></p-button>
                                            <p-button label="Delete" icon="pi pi-trash" severity="danger" [raised]="true" variant="text" (click)="onDeleteForm(form)"  type="button" styleClass="md:mt=0 mt-2 md:mr-0 mr-2"></p-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </p-tabpanel>
                    <p-tabpanel *ngFor="let form of forms; let i = index" [value]="i + 1">
                        <app-form-quiz-cases [form]="form" />
                    </p-tabpanel>
                </p-tabpanels>
            </p-tabs>
        </div>
    `
})
export class FormQuiz implements OnInit {
    name: string = '';
    fields: { name: string; fields: string[] }[] = [];

    forms: any;
    showDetailDialog: boolean = false;
    selectedForm: any;
    edit: boolean = false;
    activeIndex: number = 0;

    constructor(
        private userService: UserService,
        private messageService: MessageService
    ) {}

    ngOnInit(): void {
        this.userService.getFormField().then((res) => {
            this.forms = res.data;

            this.forms = this.forms.map((form: any) => {
                if (typeof form.fields === 'string') {
                    try {
                        form.fields = JSON.parse(form.fields);
                    } catch (error) {
                        console.error('Gagal parse fields:', error);
                        form.fields = [];
                    }
                }
                // Ensure backward compatibility: if fields is array of string, wrap in group
                if (Array.isArray(form.fields) && form.fields.length && typeof form.fields[0] === 'string') {
                    form.fields = [{ name: 'Default', fields: form.fields }];
                }
                return form;
            });
        });

        this.activeIndex = Number(localStorage.getItem('activeIndex')) || 0;
    }

    addGroup(): void {
        this.fields.push({ name: '', fields: [] });
    }

    removeGroup(groupIndex: number): void {
        this.fields.splice(groupIndex, 1);
    }

    addField(groupIndex: number): void {
        this.fields[groupIndex].fields.push('');
    }

    removeField(groupIndex: number, fieldIndex: number): void {
        this.fields[groupIndex].fields.splice(fieldIndex, 1);
    }

    trackByIndex(index: number, item: any): number {
        return index;
    }

    saveForm(): void {
        const trimmedName = this.name?.trim();
        const hasEmptyGroupName = this.fields.some((group) => !group.name || group.name.trim() === '');
        const hasEmptyField = this.fields.some((group) =>
            group.fields.some((field) => !field || field.trim() === '')
        );
        const hasEmptyGroup = this.fields.some((group) => group.fields.length === 0);

        if (!trimmedName || this.fields.length === 0 || hasEmptyGroupName || hasEmptyField || hasEmptyGroup) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Warning',
                detail: 'Please fill in all the required fields and group names.'
            });
            return;
        }

        const data = {
            name: trimmedName,
            fields: this.fields.map((g) => ({
                name: g.name.trim(),
                fields: g.fields.map((f) => f.trim())
            }))
        };

        this.userService
            .addFormField(data)
            .then((res) => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Form has been saved successfully.'
                });

                this.name = '';
                this.fields = [];
                this.ngOnInit();
            })
            .catch((error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to save the form duplicate entry'
                });
                console.error(error);
            });
    }

    openDetail(form : any){
        this.showDetailDialog = true;
        this.selectedForm = form;
    }

    editForm(form : any){
        this.edit = true;
        this.name = form.name;
        // Deep copy to avoid mutating original
        this.fields = form.fields.map((g: any) => ({
            name: g.name,
            fields: [...g.fields]
        }));
        this.selectedForm = form;
    }

    closeDialog(){
        this.showDetailDialog = false;
        this.selectedForm = null;
    }

    discardForm(){
        this.name = '';
        this.fields = [];
        this.edit = false;
    }

    onDeleteForm(form: any){
        this.userService.deleteFormField({id:form.id}).then((res) => {
            this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Form has been deleted successfully.'
            });
            this.ngOnInit();
        }).catch((error) => {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to delete the form'
            });
            console.error(error);
        })
    }

    onUpdateForm(){
        const trimmedName = this.name?.trim();
        const hasEmptyGroupName = this.fields.some((group) => !group.name || group.name.trim() === '');
        const hasEmptyField = this.fields.some((group) =>
            group.fields.some((field) => !field || field.trim() === '')
        );
        const hasEmptyGroup = this.fields.some((group) => group.fields.length === 0);

        if (!trimmedName || this.fields.length === 0 || hasEmptyGroupName || hasEmptyField || hasEmptyGroup) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Warning',
                detail: 'Please fill in all the required fields and group names.'
            });
            return;
        }

        this.userService.updateFormField({
            id: this.selectedForm.id,
            name: this.name,
            fields: this.fields.map((g) => ({
                name: g.name.trim(),
                fields: g.fields.map((f) => f.trim())
            }))
        }).then((res) => {
            this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: 'Form has been updated successfully.'
            });
            this.ngOnInit();
            this.discardForm()
        }).catch((error) => {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to update the form'
            });
            console.error(error);
        })
    }

    lastTabs(index : number) {
        this.activeIndex = index;
        localStorage.setItem('activeIndex', this.activeIndex.toString());
    }

    copyGroup(groupIndex: number): void {
        const group = this.fields[groupIndex];
        if (!group) return;
        // Salin group beserta field-nya, lalu tambahkan ke fields
        this.fields.push({
            name: group.name + ' (Copy)',
            fields: [...group.fields]
        });
        this.messageService.add({
            severity: 'info',
            summary: 'Copied',
            detail: 'Group and fields duplicated.'
        });
    }
}
